import { useMemo, useState } from 'react'
import { ajaxPrefix, ajaxUrl, ajaxNonce } from 'script-params'

export class AjaxError extends Error {
  constructor(res) {
    super(`Status ${res.status}: ${res.statusText}`)
    // this.name = "AjaxError";
    this.statusCode = res.status
  }
}

const ajax = async (params) => {
  const { action, method, query, data } = {
    method: 'GET',
    ...params,
    query: { ...params.query },
  }
  query.nonce = ajaxNonce
  if (!action) return undefined
  // if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
  // }

  const url = new URL(ajaxUrl)
  url.search = new URLSearchParams({
    ...query,
    action: ajaxPrefix + action,
  }).toString()

  const fetchParams = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  if (['POST', 'PUT', 'PATCH'].includes(method) && data) {
    fetchParams.body = JSON.stringify(data)
  }

  const response = await fetch(url, fetchParams)

  if (method === 'GET' && response.status === 404) return null
  if (response.status >= 400 && response.status < 600) {
    throw new AjaxError(response)
  }

  return response.json()
}

export const useAjax = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [data, setData] = useState(undefined)

  const wrapper = async (params) => {
    setLoading(true)
    try {
      const data = await ajax(params)
      setData(data)
      setLoading(false)
      return data
    } catch (err) {
      setError(err)
      setLoading(false)
      return undefined
    }
  }

  const api = useMemo(
    () => ({
      get: (action, query) => wrapper({ action, query, method: 'GET' }),
      post: (action, data, query) =>
        wrapper({ action, data, query, method: 'POST' }),
      put: (action, data, query) =>
        wrapper({ action, data, query, method: 'PUT' }),
      patch: (action, data, query) =>
        wrapper({ action, data, query, method: 'PATCH' }),
      delete: (action, query) => wrapper({ action, query, method: 'DELETE' }),
    }),
    []
  )

  return [
    api,
    {
      error,
      loading,
      data,
    },
  ]
}
